interface IVersion {
  version: string
  format?: 'png' | 'webp'
  type: 'Global' | 'SEA' | 'KR' | 'CN' | 'ancien' | 'nouveau' | null
  note: string | null
  launcher: boolean
  launcherSelect?: boolean
  bg?: boolean
  bgFR: boolean
  bgEN: boolean
  bgSpecial?: string
  hasVideo?: boolean
  theme?: boolean
  themeFR?: boolean
  themeEN?: boolean
  firstDesign?: boolean
  secondDesign?: boolean
}

export const versionsList: IVersion[] = [
  {
    version: '3.3',
    type: 'CN',
    note: 'Le launcher CN en beta publique.',
    launcher: true,
    bgFR: false,
    bgEN: false,
    firstDesign: true,
  },
  {
    version: '3.6',
    type: null,
    note: 'Le launcher Global à son lancement.',
    launcher: true,
    bgFR: false,
    bgEN: false,
    firstDesign: true,
  },
  {
    version: '3.7',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '3.8',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '3.9',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.0',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.1',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.2',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.3',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.4',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.5',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.6',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.7',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    firstDesign: true,
  },
  {
    version: '4.8',
    type: 'ancien',
    note: `Cette version était transitoire, le texte intégré dans l'image de fond demande de télécharger la dernière version.`,
    launcher: false,
    bgFR: false,
    bgEN: false,
    bgSpecial: 'ancien',
    firstDesign: true,
  },
  {
    version: '4.8',
    type: 'nouveau',
    note: 'Cette version adopte le même design que celui de Genshin Impact.',
    launcher: true,
    bgFR: false,
    bgEN: false,
    secondDesign: true,
  },
  {
    version: '4.9',
    type: null,
    note: 'Cette version introduit les boutons sur la droite pour ouvrir les réseaux sociaux du jeu.',
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.0',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.1',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.2',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.3',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.4',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.5',
    type: 'Global',
    note: 'Image différente pour les joueurs des serveurs EU et US et les 4 ans depuis le lancement.',
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.5',
    type: 'SEA',
    note: `Capture d'écran d'un joueur SEA avec l'image prévue pour la 5.5.`,
    launcher: true,
    bgFR: false,
    bgEN: false,
    secondDesign: true,
  },
  {
    version: '5.6',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.7',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.8',
    type: null,
    note: null,
    launcher: false,
    bgFR: false,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '5.9',
    type: null,
    note: null,
    launcher: true,
    bgFR: false,
    bgEN: false,
    secondDesign: true,
  },
  {
    version: '6.0',
    type: null,
    note: null,
    launcher: true,
    bgFR: false,
    bgEN: false,
    secondDesign: true,
  },
  {
    version: '6.1',
    type: null,
    note: null,
    launcher: true,
    bgFR: false,
    bgEN: false,
    secondDesign: true,
  },
  {
    version: '6.2',
    type: null,
    note: null,
    launcher: true,
    bgFR: false,
    bgEN: false,
    secondDesign: true,
  },
  {
    version: '6.3',
    type: null,
    note: `Le launcher a maintenant un menu dans le bouton principal avec :<br/>
- Emplacement de l'installation<br/>
- Tout réparer<br/>
- Supprimer les ressources de téléchargement<br/>
- Vérifier les mises à jour du jeu`,
    launcher: true,
    bgFR: true,
    bgEN: false,
    secondDesign: true,
  },
  {
    version: '6.4',
    type: 'Global',
    note: 'Image différente pour les joueurs des serveurs EU et US et les 5 ans depuis le lancement.',
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '6.4',
    type: 'SEA',
    note: `L'image de fond prévue pour la 6.4.`,
    launcher: false,
    bgFR: false,
    bgEN: false,
    bgSpecial: 'sea',
    secondDesign: true,
  },
  {
    version: '6.5',
    type: null,
    note: null,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '6.6',
    type: null,
    note: null,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '6.7',
    type: null,
    note: null,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '6.8',
    type: null,
    note: null,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '6.9',
    type: null,
    note: null,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.0',
    type: 'Global',
    note: `Un bouton a été ajouté dans la barre de titre, à gauche de celui des options, pour ouvrir le dossier des captures d'écran.`,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.0',
    type: 'SEA',
    note: 'Image différente pour les joueurs du serveur SEA et les 6 ans depuis le lancement.',
    launcher: false,
    bgFR: false,
    bgEN: false,
    bgSpecial: 'sea',
    secondDesign: true,
  },
  {
    version: '7.0',
    type: 'KR',
    note: 'Image différente pour les joueurs du serveur KR et les 6 ans depuis le lancement.',
    launcher: false,
    bgFR: false,
    bgEN: false,
    bgSpecial: 'kr',
    secondDesign: true,
  },
  {
    version: '7.1',
    type: null,
    note: null,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.2',
    type: null,
    note: `À l'approche de la v7.3, un carrousel et un bloc pour les actualités ont été ajoutés, comme pour Genshin Impact et Honkai: Star Rail, ou le launcher CN.`,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.3',
    type: null,
    note: `Le logo du jeu a changé de style pour la seconde partie de l'histoire. L'image de fond laisse de la place pour le carrousel, utilisé pour promouvoir l'arrivée de Thelema à l'approche de la v7.4.`,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.4',
    type: null,
    note: `<small>L'image "sélect" est celle qui s'affiche dans HoYoPlay sur l'écran de sélection des jeux. Jusqu'à la 7.8, cela était disponible uniquement en Chine.</small>`,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.5',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.6',
    type: null,
    note: `<small>L'image "sélect" en Chine pour cette version est différente de celle de fond.</small>`,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.7',
    type: null,
    note: `<small>L'image "sélect" de cette version est celle de HoYoPlay Chine. En version Globale pour l'attente, celle de la 7.4 était affichée.</small>`,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.8',
    format: 'webp',
    type: 'CN',
    note: 'Image différente pour les joueurs du serveur CN et les 8 ans depuis le lancement.',
    launcher: false,
    launcherSelect: true,
    bgFR: false,
    bgEN: false,
    bgSpecial: 'cn',
  },
  {
    version: '7.8',
    type: 'ancien',
    note: null,
    launcher: true,
    bgFR: true,
    bgEN: true,
    secondDesign: true,
  },
  {
    version: '7.8',
    format: 'webp',
    type: 'nouveau',
    note: `Intégration activée dans le launcher unifié HoYoPlay.<br/>
La mention "Vous êtes sur le [Serveur Europe et Amériques]" est écrite en dur dans l'image de fond.<br/>
L'image "sélect" de cette version ressemble à la 7.6 de Chine et est différente de celle de fond.<br/>
<small>(<a href="/img/launchers/7.8-launcher-nouveau.mp4" target="_blank">Aperçu vidéo</a>, capture d'écran
<a href="/img/launchers/7.8-launcher-preview.png" target="_blank">avant l'activation</a> et
<a href="/img/launchers/7.8-launcher-select.png" target="_blank">sélection du jeu</a>.)</small>
`,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
  },
  {
    version: '7.9',
    format: 'webp',
    type: null,
    note: `Une page de choix du serveur s'affiche la première fois que vous sélectionnez le jeu. <small><a href="/img/launchers/7.9-launcher-select.png" target="_blank">(image)</a></small>`,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
  },
  {
    version: '8.0',
    format: 'webp',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
  },
  {
    version: '8.1',
    format: 'webp',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
  },
  {
    version: '8.2',
    format: 'webp',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
  },
  {
    version: '8.3',
    format: 'webp',
    type: null,
    note: `Cette capture d'écran a été prise de la variante indépendante, téléchargée depuis le "Google Play Jeux" pour PC.<br/>
Celle-ci n'intègre pas de changement de région ou la sélection des autres jeux HoYoverse.`,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
  },
  {
    version: '8.4',
    format: 'webp',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
  },
  {
    version: '8.5',
    format: 'webp',
    type: 'CN',
    note: 'Image différente pour les joueurs du serveur CN et les 9 ans depuis le lancement.',
    launcher: false,
    launcherSelect: true,
    bgFR: false,
    bgEN: false,
    bgSpecial: 'cn',
  },
  {
    version: '8.5',
    format: 'webp',
    type: null,
    note: 'La barre latérale à gauche est désormais semi-transparente.',
    launcher: true,
    launcherSelect: true,
    bgFR: true,
    bgEN: true,
  },
  {
    version: '8.6',
    format: 'webp',
    type: null,
    note: 'Un fond animé est désormais utilisé dans le launcher.',
    launcher: true,
    launcherSelect: true,
    bg: true,
    bgFR: false,
    bgEN: false,
    hasVideo: true,
    themeFR: true,
    themeEN: true,
  },
  {
    version: '8.7',
    format: 'webp',
    type: null,
    note: '<small>Une erreur : le "thème" en anglais précise SEA même en version Globale.</small>',
    launcher: true,
    launcherSelect: true,
    bg: true,
    bgFR: true,
    bgEN: true,
    hasVideo: true,
    themeFR: true,
    themeEN: true,
  },
  {
    version: '8.8',
    format: 'webp',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bg: true,
    bgFR: false,
    bgEN: false,
    hasVideo: true,
    themeFR: true,
    themeEN: true,
  },
  {
    version: '8.9',
    format: 'webp',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bg: true,
    bgFR: true,
    bgEN: true,
    hasVideo: true,
    themeFR: true,
    themeEN: true,
  },
  {
    version: '9.0',
    format: 'webp',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bg: true,
    bgFR: false,
    bgEN: false,
    hasVideo: true,
    themeFR: true,
    themeEN: true,
  },
  {
    version: '9.1',
    format: 'webp',
    type: null,
    note: null,
    launcher: true,
    launcherSelect: true,
    bg: true,
    bgFR: false,
    bgEN: false,
    hasVideo: true,
    themeFR: true,
    themeEN: true,
  },
  {
    version: '9.1',
    format: 'webp',
    type: 'CN',
    note: 'Image différente pour les joueurs du serveur CN et les 10 ans depuis le lancement.',
    launcher: false,
    launcherSelect: false,
    bg: true,
    bgFR: false,
    bgEN: false,
    theme: true,
    hasVideo: true,
    themeFR: false,
    themeEN: false,
  },
]

export type { IVersion }
